"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNextApiErrorDtoLike = exports.isNextApiErrorLike = exports.isNextApiError = exports.NextApiError = void 0;
var http_status_codes_1 = require("http-status-codes");
var utils_1 = require("./utils");
/**
 * An error from the Next API. We standardize the shape of errors that are thrown by the API by wrapping all of the
 * functions in an error middleware function.
 */
var NextApiError = /** @class */ (function (_super) {
    __extends(NextApiError, _super);
    function NextApiError(options) {
        var _this = this;
        var method = options.method, statusCode = options.statusCode, url = options.url, data = options.data;
        var statusText = http_status_codes_1.getStatusText(statusCode);
        _this = _super.call(this, statusText) || this;
        _this.url = url;
        _this.method = method;
        _this.data = data;
        _this.name = _this.constructor.name;
        _this.statusCode = statusCode;
        _this.statusText = statusText;
        _this.isClientError = statusCode >= 400 && statusCode < 500;
        _this.isServerError = statusCode >= 500;
        _this.isAuthenticationError = statusCode === 401;
        _this.isAuthorizationError = statusCode === 403;
        _this.isNotFoundError = statusCode === 404;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, _this.constructor);
        }
        else {
            _this.stack = new Error(statusText).stack;
        }
        return _this;
    }
    return NextApiError;
}(Error));
exports.NextApiError = NextApiError;
/**
 * Is the error object a NextApiError?
 * @param error
 */
function isNextApiError(error) {
    if (!error) {
        return false;
    }
    return error instanceof NextApiError;
}
exports.isNextApiError = isNextApiError;
/**
 * Is the error object NextApiErrorLike?
 * @param error
 */
function isNextApiErrorLike(error) {
    return isNextApiError(error) || (utils_1.isObjectLike(error) && error.isClientError != null && error.isServerError != null);
}
exports.isNextApiErrorLike = isNextApiErrorLike;
/**
 * Is the response a Next API error?
 * @param data
 */
function isNextApiErrorDtoLike(data) {
    if (!data)
        return false;
    return utils_1.isObjectLike(data) && utils_1.isNumber(data.statusCode) && Array.isArray(data.errors) && utils_1.isString(data.statusText);
}
exports.isNextApiErrorDtoLike = isNextApiErrorDtoLike;
